module.exports = __webpack_public_path__ + "img/success.5ddff18e.png";